/* EVD Our Story — animations v4 (JS-driven manual interpolation, bulletproof) */
(function(){
  if(typeof window === 'undefined') return;

  function init(){
    var root = document.querySelector('.evd-os');
    if(!root) return;

    // Stagger indices
    function stagger(parentSel, childSel){
      var parents = root.querySelectorAll(parentSel);
      parents.forEach(function(p){
        Array.prototype.forEach.call(p.querySelectorAll(childSel), function(k, i){ k.style.setProperty('--i', i); });
      });
    }
    stagger('.evd-os-hero-features', '.evd-os-hero-feat');
    stagger('.evd-os-timeline', '.evd-os-mile');
    stagger('.evd-os-stats-inner', '.evd-os-stat');
    stagger('.evd-os-team-imgs', '.evd-os-team-img');
    var teamText = root.querySelector('.evd-os-team-text'); if(teamText){ Array.prototype.forEach.call(teamText.children, function(k, i){ k.style.setProperty('--i', i); }); }
    var promiseMid = root.querySelector('.evd-os-promise-mid'); if(promiseMid){ Array.prototype.forEach.call(promiseMid.children, function(k, i){ k.style.setProperty('--i', i); }); }
    var plist = root.querySelector('.evd-os-promise-list'); if(plist){ Array.prototype.forEach.call(plist.children, function(li, i){ li.style.setProperty('--i', i); }); }

    document.body.classList.add('evd-os-anims-on');

    var targetSel = '.evd-os-hero-eyebrow,.evd-os-hero-title,.evd-os-hero-sub,.evd-os-hero-visual,.evd-os-hero-feat,.evd-os-journey-eyebrow,.evd-os-journey-title,.evd-os-journey-sub,.evd-os-mile,.evd-os-stat,.evd-os-mission-eyebrow,.evd-os-mission-title,.evd-os-mission-sub,.evd-os-mission-btn,.evd-os-mission-visual,.evd-os-team-text,.evd-os-team-img,.evd-os-promise-img,.evd-os-promise-mid,.evd-os-promise-badge,.evd-os-promise-list,.evd-os-nl-text,.evd-os-nl-form';
    var targets = Array.prototype.slice.call(root.querySelectorAll(targetSel));

    var revealed = new WeakSet();

    // Manual JS interpolation fallback (in case CSS animations don't kick in)
    function manualReveal(el){
      if(revealed.has(el)) return;
      revealed.add(el);
      el.classList.add('is-in');

      // ALSO drive opacity/transform via inline style with setInterval-based interpolation as backup
      var styles = window.getComputedStyle(el);
      // Skip if CSS animation will handle it (animation-duration > 0)
      var animDur = styles.animationDuration;
      // Compute the starting transform/opacity based on class
      var fromOpacity = 0;
      var fromTransform = 'translateY(34px)';
      if(el.classList.contains('evd-os-hero-visual')) fromTransform = 'translateX(44px)';
      else if(el.classList.contains('evd-os-mission-visual') || el.classList.contains('evd-os-promise-img')) fromTransform = 'translateX(-44px)';
      else if(el.classList.contains('evd-os-team-img')) fromTransform = 'scale(0.88)';
      else if(el.classList.contains('evd-os-promise-badge')) fromTransform = 'scale(0.5) rotate(-20deg)';

      // Read --i for stagger delay
      var iVar = parseInt(el.style.getPropertyValue('--i')) || 0;
      var delayMs = iVar * 90;

      el.style.opacity = '0';
      el.style.transform = fromTransform;
      el.style.willChange = 'opacity, transform';

      var duration = 900;
      setTimeout(function(){
        var start = performance.now();
        function frame(now){
          var t = Math.min(1, (now - start) / duration);
          // easeOutExpo
          var eased = t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
          el.style.opacity = String(eased);
          el.style.transform = interpTransform(fromTransform, eased);
          if(t < 1){ requestAnimationFrame(frame); }
          else { el.style.opacity = '1'; el.style.transform = 'none'; el.style.willChange = 'auto';
            if(el.classList.contains('evd-os-stat')){
              var n = el.querySelector('.evd-os-stat-num');
              if(n) countUp(n);
            }
            // Trigger promise badge pulse
            if(el.classList.contains('evd-os-promise-badge')){
              pulseBadge(el);
            }
          }
        }
        requestAnimationFrame(frame);
      }, delayMs);
    }

    function interpTransform(from, t){
      // Parse simple translateY(Npx), translateX(Npx), scale(N), scale(N) rotate(Ndeg)
      var m;
      if((m = from.match(/translateY\(([-\d.]+)px\)/))){
        var v = parseFloat(m[1]) * (1 - t);
        return 'translateY(' + v.toFixed(2) + 'px)';
      }
      if((m = from.match(/translateX\(([-\d.]+)px\)/))){
        var v = parseFloat(m[1]) * (1 - t);
        return 'translateX(' + v.toFixed(2) + 'px)';
      }
      if(from.indexOf('rotate') >= 0 && from.indexOf('scale') >= 0){
        // scale(0.5) rotate(-20deg) -> scale(1) rotate(0)
        var s = 0.5 + (1 - 0.5) * t;
        var r = -20 * (1 - t);
        return 'scale(' + s.toFixed(3) + ') rotate(' + r.toFixed(2) + 'deg)';
      }
      if((m = from.match(/scale\(([\d.]+)\)/))){
        var fs = parseFloat(m[1]);
        var ss = fs + (1 - fs) * t;
        return 'scale(' + ss.toFixed(3) + ')';
      }
      return 'none';
    }

    function pulseBadge(el){
      var rings = 3;
      var i = 0;
      function ring(){
        if(i++ >= rings) return;
        el.animate([
          {boxShadow: '0 0 0 0 rgba(196,30,58,0.55)'},
          {boxShadow: '0 0 0 20px rgba(196,30,58,0)'}
        ], {duration: 2400, easing: 'ease-out'});
        setTimeout(ring, 800);
      }
      ring();
    }

    function checkReveal(){
      var vh = window.innerHeight;
      targets.forEach(function(el){
        if(revealed.has(el)) return;
        var r = el.getBoundingClientRect();
        if(r.top < vh - 50 && r.bottom > 0){
          manualReveal(el);
        }
      });
    }

    setTimeout(checkReveal, 80);
    setTimeout(checkReveal, 300);
    setTimeout(checkReveal, 900);
    var scrollTicking = false;
    window.addEventListener('scroll', function(){
      if(scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(function(){ checkReveal(); scrollTicking = false; });
    }, { passive: true });
    window.addEventListener('resize', checkReveal, { passive: true });

    function countUp(el){
      if(!el || el.dataset.counted) return;
      el.dataset.counted = '1';
      var raw = el.textContent.trim();
      var m = raw.match(/^([^\d.]*)([0-9.,]+)(.*)$/);
      if(!m){ return; }
      var prefix = m[1] || '';
      var numStr = m[2].replace(/,/g,'');
      var suffix = m[3] || '';
      var endNum = parseFloat(numStr);
      if(!isFinite(endNum)){ return; }
      var decimals = (numStr.split('.')[1] || '').length;
      var hasComma = m[2].indexOf(',') >= 0;
      var duration = 1600;
      var startTime = performance.now();
      el.classList.add('counting');
      function frame(now){
        var t = Math.min(1, (now - startTime) / duration);
        var eased = 1 - Math.pow(1 - t, 3);
        var v = endNum * eased;
        var disp;
        if(decimals > 0){ disp = v.toFixed(decimals); }
        else { disp = Math.round(v).toString(); if(hasComma) disp = disp.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
        el.textContent = prefix + disp + suffix;
        if(t < 1){ requestAnimationFrame(frame); }
        else { el.classList.remove('counting'); el.textContent = raw; }
      }
      requestAnimationFrame(frame);
    }

    // Parallax watermark
    var wm = root.querySelector('.evd-os-hero-bg-watermark');
    var hero = root.querySelector('.evd-os-hero');
    if(wm && hero){
      var ticking2 = false;
      window.addEventListener('scroll', function(){
        if(ticking2) return;
        ticking2 = true;
        requestAnimationFrame(function(){
          var r = hero.getBoundingClientRect();
          if(r.bottom > 0 && r.top < window.innerHeight){
            var progress = -r.top / window.innerHeight;
            wm.style.transform = 'translateY(-50%) translateX(' + (progress * 40) + 'px)';
          }
          ticking2 = false;
        });
      }, { passive: true });
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
